module.exports = __webpack_public_path__ + "img/onb2.6b9112d1.svg";